import { render, staticRenderFns } from "./sectionPersonelListMob.vue?vue&type=template&id=0caa6b6a&scoped=true&"
import script from "./sectionPersonelListMob.vue?vue&type=script&lang=js&"
export * from "./sectionPersonelListMob.vue?vue&type=script&lang=js&"
import style0 from "./sectionPersonelListMob.vue?vue&type=style&index=0&id=0caa6b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caa6b6a",
  null
  
)

export default component.exports